import mixpanel from 'mixpanel-browser';
// Actions
import { setAlert  } from './alertActions';
import { sendEmail } from './emailActions';

// Firebase
import { db, auth, storage, functions } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, serverTimestamp, orderBy, increment, startAfter, limit, onSnapshot, writeBatch } from 'firebase/firestore';
import { uploadBytes, ref, getDownloadURL, uploadBytesResumable, deleteObject } from 'firebase/storage';
import { httpsCallable } from 'firebase/functions';

// DraftJS
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

import {
    GET_POSTS,
    SET_POSTS,
    SET_LAST_POSTS,
    GET_POST,
    UPDATE_POST_LIKES,
    ADD_POST,
    DELETE_POST,
    GET_COMMENTS,
    SET_COMMENTS,
    ADD_COMMENT,
    REMOVE_COMMENT,
    COMMENTS_LOADING,
    POSTS_LOADING,
    CLEAR_POSTS,
    CLEAR_POST,
    POST_ERROR,
    UPDATE_EDITOR_TEXT,
    CLEAR_EDITOR_TEXT,
    UPDATE_EDITOR_CATEGORY,
    CLEAR_EDITOR_CATEGORY,
    UPDATE_EDITOR_FILES,
    REMOVE_EDITOR_FILE,
    CLEAR_EDITOR_FILES,
    UPDATE_URLS,
    REMOVE_URL,
    CLEAR_URLS,
    UPDATE_LAST_POST_ADDED,
    POST_UPLOADING,
    POST_UPLOADING_IMGS,
    SET_SHOW_BOTTOM_SPINNER, 
    SET_LAST_PAGE_DOC, 
    SET_NO_MORE_POSTS
} from './types';

// Constant Variables
import PRIVATE_TYPES from '../utils/constant_variables/PRIVATE_TYPES';
import { getAdsTurnToPosts_Helper } from './adActions';
import safeTrackPostAnalytics from '../utils/reusable_functions/safeTrackPostAnalytics';
import replaceHyphenWithSpace from '../utils/reusable_functions/replace_Hyphens_With_Space';
import MAX_FOLLOW_COUNT from '../utils/constant_variables/MAX_FOLLOW_COUNT';

// Reference to the "posts" collection in Firestore
const postsCollectionRef = collection(db, "posts");
const reviewsCollectionRef = collection(db, "reviews");

// Declare cloud function for use in this file
const createNotification_InCloud = httpsCallable(functions, 'createNotification');

const removeHtmlTags = (str) => {
    if ((str===null) || (str===''))
        return false;
    else
        str = str.toString();
          
    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string and replace non-breaking spaces (&nbsp;) with regular spaces.
    return str.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/g, ' ');
}

// Get Posts - For You Feed
export const getForYouPosts = ({lastPageDoc, analyticsMetaData, filter_tags}) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());

    console.log('GETTING FOR YOU POSTS');

    const PAGE_LIMIT = 25;

    try {
        console.log('QUERYING FOR YOU POSTS');

        let match_filter_tags = filter_tags?.map(tag => replaceHyphenWithSpace(tag)) || [];

        // Create a query to retrieve posts 
        let q = query(postsCollectionRef, 
            where("post_commented_on", "==", null), 
            where("type", "==", "post"),
            where("group_is_private", "==", false),
            // add more where("field" == tag)'s for each tag in filter_tags (if it's not null)
            // caution: each unique tag must have its own index ('loooking for' & 'for sale' require two seperate indexes)
            ...(match_filter_tags?.length > 0 ? match_filter_tags.map(tag => where(`filter_tags.${tag}`, "==", true)) : []),
            orderBy('createdAt', 'desc'),
            ...(lastPageDoc ? [startAfter(lastPageDoc)] : []), 
            limit(PAGE_LIMIT)
        );

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING FOR YOU POSTS...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // Recursively fetch comments of comments
        const fetchCommentsOfComments = async (comments) => {
            for (let i = 0; i < comments.length; i++) {
            const comment = comments[i];
            
            // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
            const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
            
            // Execute the query and retrieve the query snapshot
            const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
            
            // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
            const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
            // Append the comments of comments to the current comment
            comment.commentsOfComments = commentsOfComments;
            
            // Recursively fetch comments of comments for the current comment
            await fetchCommentsOfComments(commentsOfComments);
            }
        };
        
        // Fetch comments of comments for the initial set of comments
        await fetchCommentsOfComments(postList);

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        let final_post_list = postList;

        // -- Insert Sponsored posts --
        try {
            const postsWithAds = await insertSponsoredPosts({posts: postList, analyticsMetaData});
            final_post_list = [...postsWithAds];
        } catch (error) {
            console.log("Failed to insert ads into posts");
            console.log(error);
        }
        // -- END: Insert Sponsored posts --

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: final_post_list
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: final_post_list
            });
        }

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with an empty array as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
};

// Get single Post by id
export const getPostById = id => async dispatch => {
    dispatch(setPostsLoading());
    try {

        // Create a reference to the specified post document in the "posts" collection
        const docRef = doc(db, 'posts', id)

        // Retrieve the document with the specified ID from the "posts" collection
        const postDoc = await getDoc(docRef);

        console.log('GOT POST BY ID');
  
        if(postDoc.data()) {
            // Dispatch an action of type GET_POST with the post data and ID as the payload
            dispatch({
                type: GET_POST,
                payload: {
                    ...postDoc.data(),
                    _id: id
                }
            });
        } else {
            dispatch({
                type: GET_POST,
                payload: null
            });

            dispatch(setAlert('Sorry, that post has been deleted.', 'okay'));
        }
    } catch (err) {

        // Dispatch an action of type POST_ERROR with an error message and status code as the payload
        dispatch({
            type: POST_ERROR,
            payload: { msg: "something went wrong", status: 500 }
        });
        
        // Log the error to the console
        console.log(err);
    }
}

// Get Posts By User Id
export const getPostsByUserId = ({ user_id, lastPageDoc, website }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());

    console.log('GETTING USER POSTS');

    const PAGE_LIMIT = 10;

    try {
        console.log('QUERYING USER POSTS');

        // Create a query to retrieve posts where the user ID matches the provided ID, ordered by creation date in descending order
        let q;

        if(website?._id) {
            if(lastPageDoc) {
                // Create a new query to retrieve posts starting at the last visible document
                q = query(postsCollectionRef, where("group._id", "==", website._id), where("user._id", "==", user_id), where("post_commented_on", "==", null), where("type", "==", "post"), orderBy('lastModified', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
              
            } else {
                // Create a query to retrieve posts 
                q = query(postsCollectionRef, where("group._id", "==", website._id), where("user._id", "==", user_id), where("post_commented_on", "==", null),where("type", "==", "post"), orderBy('lastModified', 'desc'), limit(PAGE_LIMIT));
            }
        } else {
            if(lastPageDoc) {
                // Create a new query to retrieve posts starting at the last visible document
                q = query(postsCollectionRef, where("user._id", "==", user_id), where("post_commented_on", "==", null), where("type", "==", "post"), orderBy('lastModified', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
              
            } else {
                // Create a query to retrieve posts 
                q = query(postsCollectionRef, where("user._id", "==", user_id), where("post_commented_on", "==", null),where("type", "==", "post"), orderBy('lastModified', 'desc'), limit(PAGE_LIMIT));
            }
        }

        onSnapshot(q, async (snapshot) => {
            console.log('UPDATING USER POSTS...');
            const tempPostList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

            // Recursively fetch comments of comments
            const fetchCommentsOfComments = async (comments) => {
                for (let i = 0; i < comments.length; i++) {
                const comment = comments[i];
                
                // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
                const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
                
                // Execute the query and retrieve the query snapshot
                const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
                
                // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
                const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
                
                // Append the comments of comments to the current comment
                comment.commentsOfComments = commentsOfComments;
                
                // Recursively fetch comments of comments for the current comment
                await fetchCommentsOfComments(commentsOfComments);
                }
            };
            
            // Fetch comments of comments for the initial set of comments
            await fetchCommentsOfComments(tempPostList);
    
            let lastDocument = tempPostList[tempPostList.length - 1];

            if(lastDocument) {

                // Create a reference to the specified post document in the "posts" collection 
                const docRef = doc(postsCollectionRef, lastDocument._id);
    
                // Retrieve the document with the specified ID from the "posts" collection
                const postDoc = await getDoc(docRef);
    
                // Set the last visible document for the next load
                dispatch({
                    type: SET_LAST_PAGE_DOC,
                    payload: postDoc
                });
    
                dispatch(set_ShowBottomSpinner(false));
            }

            // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
            if(tempPostList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
                dispatch({
                    type: SET_LAST_POSTS,
                    payload: tempPostList
                });
            } else {
                dispatch({
                    type: SET_POSTS,
                    payload: tempPostList
                });
            }
            
        })

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with an empty array as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
};

// Get Posts By Group Id
export const getPostsByGroupId = ({ group_id, lastPageDoc, filter_tags }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());

    console.log('GETTING GROUP POSTS');

    const PAGE_LIMIT = 25;

    try {
        console.log('QUERYING GROUP POSTS');

        let match_filter_tags = filter_tags?.map(tag => replaceHyphenWithSpace(tag)) || [];

        // Create a query to retrieve posts 
        let q = query(postsCollectionRef, 
            where("group._id", "==", group_id),
            where("post_commented_on", "==", null), 
            // add more where("field" == tag)'s for each tag in filter_tags (if it's not null)
            // caution: each unique tag must have its own index ('loooking for' & 'for sale' require two seperate indexes)
            ...(match_filter_tags?.length > 0 ? match_filter_tags.map(tag => where(`filter_tags.${tag}`, "==", true)) : []),
            orderBy('lastModified', 'desc'),
            ...(lastPageDoc ? [startAfter(lastPageDoc)] : []), 
            limit(PAGE_LIMIT)
        );

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING GROUP POSTS...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // Recursively fetch comments of comments
        const fetchCommentsOfComments = async (comments) => {
            for (let i = 0; i < comments.length; i++) {
            const comment = comments[i];
            
            // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
            const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
            
            // Execute the query and retrieve the query snapshot
            const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
            
            // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
            const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
            // Append the comments of comments to the current comment
            comment.commentsOfComments = commentsOfComments;
            
            // Recursively fetch comments of comments for the current comment
            await fetchCommentsOfComments(commentsOfComments);
            }
        };
        
        // Fetch comments of comments for the initial set of comments
        await fetchCommentsOfComments(postList);

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: postList
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: postList
            });
        }

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with an empty array as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
};

// Get Posts By Group Id
export const getPostsFromGroupsFollowing = (currentUser, lastPageDoc) => async dispatch => {

    if(!currentUser) throw new Error('No user data');

    if(!lastPageDoc) dispatch(setPostsLoading());

    console.log('GETTING FOLLOWING POSTS');

    const PAGE_LIMIT = 25;

    const followedGroups = currentUser?.groups?.slice(0, MAX_FOLLOW_COUNT) || [];

    // Flag - Can't query empty arrays. Firebase will throw error: non-empty array is required for 'in' filters
    if(followedGroups <= 0) {
        console.log("Doesn't follow any groups");
        dispatch({
            type: SET_POSTS,
            payload: []
        })
        return;
    }

    try {
        console.log('QUERYING FOLLOWING POSTS');

        // Create a query to retrieve posts where the user ID matches the provided ID, ordered by creation date in descending order
        let q;

        if(lastPageDoc) {
            // Create a new query to retrieve posts starting at the last visible document
            q = query(postsCollectionRef, where('group._id', 'in', followedGroups), where("post_commented_on", "==", null), where("type", "==", "post"), orderBy('lastModified', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
          
        } else {
            // Create a query to retrieve posts 
            q = query(postsCollectionRef, where('group._id', 'in', followedGroups), where("post_commented_on", "==", null), where("type", "==", "post"), orderBy('lastModified', 'desc'), limit(PAGE_LIMIT));
        }

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING FOLLOWING POSTS...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // Recursively fetch comments of comments
        const fetchCommentsOfComments = async (comments) => {
            for (let i = 0; i < comments.length; i++) {
            const comment = comments[i];
            
            // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
            const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
            
            // Execute the query and retrieve the query snapshot
            const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
            
            // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
            const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
            // Append the comments of comments to the current comment
            comment.commentsOfComments = commentsOfComments;
            
            // Recursively fetch comments of comments for the current comment
            await fetchCommentsOfComments(commentsOfComments);
            }
        };
        
        // Fetch comments of comments for the initial set of comments
        await fetchCommentsOfComments(postList);

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: postList
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: postList
            });
        }

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with an empty array as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
};


// filter the posts with images attached
export const getGroupPhotos = ({ group_id, lastPageDoc }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());

    console.log('GETTING GALLERY POSTS');

    const PAGE_LIMIT = 10;
    
    try {
        console.log('QUERYING GALLERY POSTS');

        // Create a query to retrieve posts where the user ID matches the provided ID, 
        // the image count is greater than or equal to 1, 
        // ordered by image count and creation date in descending order

        let q;

        if(lastPageDoc) {
            // Create a new query to retrieve posts starting at the last visible document
            q = query(postsCollectionRef, where("group._id", "==", group_id), where("hasPhoto", "==", true), orderBy('createdAt', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
          
        } else {
            // Create a query to retrieve posts 
            q = query(postsCollectionRef, where("group._id", "==", group_id), where("hasPhoto", "==", true), orderBy('createdAt', 'desc'), limit(PAGE_LIMIT));
        }

        // Execute the query and retrieve the query snapshot
        const snapshot = await getDocs(q);

        console.log('UPDATING USER PHOTOS...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // -- Get ALL images from each post

        // Collect all image from posts
        let posts_With_All_Imgs = [];

        if(postList?.length > 0) {
            // Function to get post images
            async function getPostImgs(postId) {
                const docRef = doc(db, 'posts', postId)
                const colRef = collection(docRef, "img_gallery")
                
                try {
                    const galleryData = await getDocs(colRef);
                    const galleryList = galleryData.docs.map((doc) => ({...doc.data(), id: doc.id}));
                    return galleryList;
                } catch (err) {
                    console.log('ERROR:', err);
                    return [];
                }
            }

            // Use for...of to properly await async operations
            for (const post_doc of postList) {
                const postImgs = await getPostImgs(post_doc._id);

                for (const img_obj of postImgs) {
                    const imgInfo = {
                        ...post_doc,
                        img_path: img_obj.img_path,
                        img_name: img_obj.img_name,
                        width: img_obj.img_width,
                        height: img_obj.img_height
                    };
                
                    posts_With_All_Imgs.push(imgInfo);
                }
            }
        }

        // -- END: Get ALL images from each post

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        console.log('DONE GETTING GALLERY POSTS');

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: posts_With_All_Imgs
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: posts_With_All_Imgs
            });
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// filter the posts with images attached
export const getUserPhotos = ({ user_id, lastPageDoc, website }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());

    console.log('GETTING GALLERY POSTS');

    const PAGE_LIMIT = 10;
    
    try {
        console.log('QUERYING GALLERY POSTS');

        // Create a query to retrieve posts where the user ID matches the provided ID, 
        // the image count is greater than or equal to 1, 
        // ordered by image count and creation date in descending order

        let q;

        if(website?._id) {
            if(lastPageDoc) {
                // Create a new query to retrieve posts starting at the last visible document
                q = query(postsCollectionRef, where("group._id", "==", website._id), where("user._id", "==", user_id), where("hasPhoto", "==", true), orderBy('createdAt', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
              
            } else {
                // Create a query to retrieve posts 
                q = query(postsCollectionRef, where("group._id", "==", website._id), where("user._id", "==", user_id), where("hasPhoto", "==", true), orderBy('createdAt', 'desc'), limit(PAGE_LIMIT));
            }
        } else {
            if(lastPageDoc) {
                // Create a new query to retrieve posts starting at the last visible document
                q = query(postsCollectionRef, where("user._id", "==", user_id), where("hasPhoto", "==", true), orderBy('createdAt', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
              
            } else {
                // Create a query to retrieve posts 
                q = query(postsCollectionRef, where("user._id", "==", user_id), where("hasPhoto", "==", true), orderBy('createdAt', 'desc'), limit(PAGE_LIMIT));
            }
        }

        // Execute the query and retrieve the query snapshot
        const snapshot = await getDocs(q);

        console.log('UPDATING USER PHOTOS...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // -- Get ALL images from each post

        // Collect all image from posts
        let posts_With_All_Imgs = [];

        if(postList?.length > 0) {
            // Function to get post images
            async function getPostImgs(postId) {
                const docRef = doc(db, 'posts', postId)
                const colRef = collection(docRef, "img_gallery")
                
                try {
                    const galleryData = await getDocs(colRef);
                    const galleryList = galleryData.docs.map((doc) => ({...doc.data(), id: doc.id}));
                    return galleryList;
                } catch (err) {
                    console.log('ERROR:', err);
                    return [];
                }
            }

            // Use for...of to properly await async operations
            for (const post_doc of postList) {
                const postImgs = await getPostImgs(post_doc._id);

                for (const img_obj of postImgs) {
                    const imgInfo = {
                        ...post_doc,
                        img_path: img_obj.img_path,
                        width: img_obj.img_width,
                        height: img_obj.img_height
                    };
                
                    posts_With_All_Imgs.push(imgInfo);
                }
            }
        }

        // -- END: Get ALL images from each post

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: posts_With_All_Imgs
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: posts_With_All_Imgs
            });
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// filter the posts with images attached
export const getUserReplies = ({ user_id, lastPageDoc, website }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());
    
    console.log('GETTING USER REPLIES');

    const PAGE_LIMIT = 10;

    try {
        console.log('QUERYING USER REPLIES');

        // Create a query to retrieve posts where the user ID matches the provided ID, 
        let q;

        if(lastPageDoc) {
            // Create a new query to retrieve posts starting at the last visible document
            q = query(postsCollectionRef, where("user._id", "==", user_id), where("post_commented_on", "!=", null), orderBy('post_commented_on'), orderBy('lastModified', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
          
        } else {
            // Create a query to retrieve posts 
            q = query(postsCollectionRef, where("user._id", "==", user_id), where("post_commented_on", "!=", null), orderBy('post_commented_on'), orderBy('lastModified', 'desc'), limit(PAGE_LIMIT));
        }

        // Execute the query and retrieve the query snapshot
        onSnapshot(q, async (snapshot) => {
            console.log('UPDATING USER REPLIES...');
            const tempPostList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

            // Recursively fetch comments of comments
            const fetchCommentsOfComments = async (comments) => {
                for (let i = 0; i < comments.length; i++) {
                const comment = comments[i];
                
                // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
                const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
                
                // Execute the query and retrieve the query snapshot
                const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
                
                // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
                const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
                
                // Append the comments of comments to the current comment
                comment.commentsOfComments = commentsOfComments;
                
                // Recursively fetch comments of comments for the current comment
                await fetchCommentsOfComments(commentsOfComments);
                }
            };
            
            // Fetch comments of comments for the initial set of comments
            await fetchCommentsOfComments(tempPostList);

            let lastDocument = tempPostList[tempPostList.length - 1];

            if(lastDocument) {

                // Create a reference to the specified post document in the "posts" collection 
                const docRef = doc(postsCollectionRef, lastDocument._id);
    
                // Retrieve the document with the specified ID from the "posts" collection
                const postDoc = await getDoc(docRef);
    
                // Set the last visible document for the next load
                dispatch({
                    type: SET_LAST_PAGE_DOC,
                    payload: postDoc
                });
    
                dispatch(set_ShowBottomSpinner(false));
            }

            // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
            if(tempPostList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
                dispatch({
                    type: SET_LAST_POSTS,
                    payload: tempPostList
                });
            } else {
                dispatch({
                    type: SET_POSTS,
                    payload: tempPostList
                });
            }
            
        })
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// filter the posts with images attached
export const getReviewsByUserId = ({ user_id, lastPageDoc }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());
    
    console.log('GETTING REVIEWS');

    const PAGE_LIMIT = 10;

    try {
        console.log('QUERYING REVIEWS');

        // Create a query to retrieve posts 
        let q = query(reviewsCollectionRef, 
            where("to_user._id", "==", user_id),
            where("type", "==", "user"),
            orderBy('createdAt', 'desc'),
            ...(lastPageDoc ? [startAfter(lastPageDoc)] : []), 
            limit(PAGE_LIMIT)
        );

        // Fetch posts
        const snapshot = await getDocs(q);

        // Execute the query and retrieve the query snapshot
        console.log('UPDATING REVIEWS...');
        const tempPostList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // Recursively fetch comments of comments
        const fetchCommentsOfComments = async (comments) => {
            for (let i = 0; i < comments.length; i++) {
            const comment = comments[i];
            
            // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
            const commentOfCommentQuery = query(reviewsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
            
            // Execute the query and retrieve the query snapshot
            const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
            
            // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
            const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
            // Append the comments of comments to the current comment
            comment.commentsOfComments = commentsOfComments;
            
            // Recursively fetch comments of comments for the current comment
            await fetchCommentsOfComments(commentsOfComments);
            }
        };
        
        // Fetch comments of comments for the initial set of comments
        await fetchCommentsOfComments(tempPostList);

        let lastDocument = tempPostList[tempPostList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified review document in the "reviews" collection 
            const docRef = doc(reviewsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(tempPostList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: tempPostList
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: tempPostList
            });
        }

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// Get single Post by id
export const getReviewById = id => async dispatch => {
    dispatch(setPostsLoading());
    try {

        // Create a reference to the specified post document in the "posts" collection
        const docRef = doc(reviewsCollectionRef, id)

        // Retrieve the document with the specified ID from the "posts" collection
        const postDoc = await getDoc(docRef);

        console.log('GOT REVIEW BY ID');
  
        if(postDoc.data()) {
            // Dispatch an action of type GET_POST with the post data and ID as the payload
            dispatch({
                type: GET_POST,
                payload: {
                    ...postDoc.data(),
                    _id: id
                }
            });
        } else {
            dispatch({
                type: GET_POST,
                payload: null
            });

            dispatch(setAlert('Sorry, that review has been deleted.', 'okay'));
        }
    } catch (err) {

        // Dispatch an action of type POST_ERROR with an error message and status code as the payload
        dispatch({
            type: POST_ERROR,
            payload: { msg: "something went wrong", status: 500 }
        });
        
        // Log the error to the console
        console.log(err);
    }
}

// Get Post Comment
export const getComments_Review = (reviewId) => async dispatch => {
    dispatch(setCommentsLoading());
    console.log('GETTING COMMENTS')

    try {
        // Create a query to retrieve comments where the post_commented_on field matches the provided post ID, ordered by creation date in descending order
        const commentQuery = query(reviewsCollectionRef, where("post_commented_on", "==", reviewId), orderBy('createdAt', 'asc'));
      
        // Execute the query and retrieve the query snapshot
        const querySnapshot = await getDocs(commentQuery);
      
        // Map through the document snapshots in the query snapshot and extract the data and ID for each comment
        const postComments = querySnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        dispatch({
            type: GET_COMMENTS,
            payload: postComments
        });
      } catch (error) {
        console.log('ERROR');
        console.log(error);
      }
}

// get all documents in the reviews collection belonging to current user
export const getMyReviews = ({ user_id, lastPageDoc }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());
    
    console.log('GETTING MY REVIEWS');

    const PAGE_LIMIT = 10;

    try {
        console.log('QUERYING MY REVIEWS');

        // Create a query to retrieve posts 
        let q = query(reviewsCollectionRef, 
            where("user._id", "==", user_id),
            orderBy('createdAt', 'desc'),
            ...(lastPageDoc ? [startAfter(lastPageDoc)] : []), 
            limit(PAGE_LIMIT)
        );

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING MY REVIEWS...');
        const tempPostList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // Recursively fetch comments of comments
        const fetchCommentsOfComments = async (comments) => {
            for (let i = 0; i < comments.length; i++) {
            const comment = comments[i];
            
            // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
            const commentOfCommentQuery = query(reviewsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
            
            // Execute the query and retrieve the query snapshot
            const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
            
            // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
            const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
            // Append the comments of comments to the current comment
            comment.commentsOfComments = commentsOfComments;
            
            // Recursively fetch comments of comments for the current comment
            await fetchCommentsOfComments(commentsOfComments);
            }
        };
        
        // Fetch comments of comments for the initial set of comments
        await fetchCommentsOfComments(tempPostList);

        let lastDocument = tempPostList[tempPostList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(reviewsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(tempPostList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: tempPostList
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: tempPostList
            });
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// Delete Post
export const deleteReview = (reviewId) => async dispatch => {
    console.log('DELETING REVIEW!!!!!')

    // Get reference to the post document
    const postRef = doc(reviewsCollectionRef, reviewId)

    try {

        // --- DELETE REVIEW ---

        // Fetch the post document
        const postDoc = await getDoc(postRef);
        
        // Delete the post document
        await deleteDoc(postRef);

        // --- END DELETE REVIEW ---
        
        if(!postDoc.data().post_commented_on) {
            // Dispatch the DELETE_POST action with the reviewId
            dispatch({
                type: DELETE_POST,
                payload: reviewId
            });

            // Clear the currently displayed post
            dispatch(clearPost());

            // Set an alert to inform the user that the post was deleted
            dispatch(setAlert('Your review was deleted', 'okay'));
        } else {

            // Dispatch the REMOVE_COMMENT action with the commentId payload to remove the comment from the state
            dispatch({
                type: REMOVE_COMMENT,
                payload: postDoc.id
            });

            // Display a success alert
            dispatch(setAlert('Comment Removed', 'success'));
        }

    } catch (err) {
        console.log('ERROR');
        console.log(err);

        dispatch(setAlert('Something went wrong', 'danger'));
    }
}

// Add like
export const addLike_Review = ({ reviewId, fromUserData, reviewData }) => async dispatch => {
    
    // Get the current list of likes from the post data
    const likeList = reviewData.likes;
    
    try {
        console.log('ADDING LIKE!!!!!')

        // Get Firebase Post & Likes of post collection ref
        const postRef = doc(reviewsCollectionRef, reviewId)
        
        // Create the new like object
        const newLike = {
            user: {
                _id: fromUserData._id,
                username: fromUserData.username,
                first_name: fromUserData.first_name,
                last_name: fromUserData.last_name,
                img: fromUserData.img
            }
        };

        // Check if review already liked by same user
        if(likeList.filter(like => like.user._id.toString() === fromUserData._id).length > 0) {
            // Get the index of the like to remove
            const removeIndex = likeList.map(like => like.user._id.toString()).indexOf(fromUserData._id);

            const likeID = likeList[removeIndex]._id;

            // Remove the like from the post
            likeList.splice(removeIndex, 1);

            // Create array for the list of like ID's
            const id_array = [];

            likeList.map((like) => {
                id_array.push(like.user._id);
            })

            // Update the post document with the updated likes and like_id_list
            await updateDoc(postRef, {
                likes: likeList,
                like_id_list: id_array
            })
        } else {
            // const likeData = await addDoc(colRef, newLike);

            // Add the new like to the likeList
            likeList.push(newLike);

            // Create array for the list of like ID's
            const id_array = [];

            likeList.map((like) => {
                id_array.push(like.user._id);
            })

            // Update the post document with the updated likes and like_id_list
            await updateDoc(postRef, {
                likes: likeList,
                like_id_list: id_array
            })

            console.log('SUCCESSFULLY LIKED');
            

            // Dispatch an alert to indicate that the post was saved
            dispatch(setAlert('Review liked.', 'okay'));

            // --- Create Notification ---- >

            if(!(reviewData.user._id === fromUserData._id)) {

                const payload = {
                    type: 'review like',
                    reviewId: reviewId,
                    message: reviewData.text,
                    toId: reviewData.user._id,
                    from_username: `${fromUserData.first_name || ""} ${fromUserData.last_name || ""}`,
                    avatar: fromUserData.img, // from user
                    date: Date.now()
                }

                // Trigger cloud function to create notification
                createNotification_InCloud(payload)
                    .then(() => console.log("Notification created successfully!"))
                    .catch((err) => console.log("Notification failed to create"));
            }

        // --- END Create Notification
        }

      
    } catch (err) {
      console.log(err)
    }
};

// filter the posts by sports match
export const getPostsBySportsMatch = ({ match, group_id, lastPageDoc, filter_tags }) => async dispatch => {
    dispatch(setPostsLoading());
    console.log('GETTING POSTS BY SPORTS MATCH');

    const PAGE_LIMIT = 10;

    try {
        if(!match) throw new Error("No sports match data provided"); 

        console.log('QUERYING POSTS BY SPORTS MATCH');

        const match_uid = match._id;
        let match_search_tags = match?.search_tags?.map(tag => tag.toLowerCase()) || [];
        let match_filter_tags = filter_tags?.map(tag => replaceHyphenWithSpace(tag)) || [];

        // Create a query to retrieve posts 
        let q = query(postsCollectionRef, 
            where("search_tags", "array-contains-any", [match_uid, ...match_search_tags]), 
            ...(group_id ? [where("group._id", "==", group_id)] : [where("group", "==", null)]),
            where("post_commented_on", "==", null), 
            // add more where("field" == tag)'s for each tag in filter_tags (if it's not null)
            // caution: each unique tag must have its own index ('loooking for' & 'for sale' require two seperate indexes)
            ...(match_filter_tags?.length > 0 ? match_filter_tags.map(tag => where(`filter_tags.${tag}`, "==", true)) : []),
            orderBy('lastModified', 'desc'), 
            ...(lastPageDoc ? [startAfter(lastPageDoc)] : []), 
            limit(PAGE_LIMIT)
        );

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING SPORTS MATCH POSTS...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // Recursively fetch comments of comments
        const fetchCommentsOfComments = async (comments) => {
            for (let i = 0; i < comments.length; i++) {
            const comment = comments[i];
            
            // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
            const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
            
            // Execute the query and retrieve the query snapshot
            const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
            
            // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
            const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
            // Append the comments of comments to the current comment
            comment.commentsOfComments = commentsOfComments;
            
            // Recursively fetch comments of comments for the current comment
            await fetchCommentsOfComments(commentsOfComments);
            }
        };
        
        // Fetch comments of comments for the initial set of comments
        await fetchCommentsOfComments(postList);

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        console.log('DONE GETTING SPORTS MATCH POSTS...');

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: postList
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: postList
            });
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// filter the posts with images attached
export const getSportsMatchPhotos = ({ match, group_id, lastPageDoc }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());
    console.log('GETTING PHOTOS BY SPORTS MATCH');

    const PAGE_LIMIT = 10;
    
    try {
        console.log('QUERYING PHOTOS BY SPORTS MATCH');

        const match_uid = match._id;
        let match_search_tags = match?.search_tags || [];

        // Create a query to retrieve posts 
        let q = query(postsCollectionRef, 
            where("search_tags", "array-contains-any", [match_uid, ...match_search_tags]), 
            ...(group_id ? [where("group._id", "==", group_id)] : [where("group", "==", null)]),
            where("hasPhoto", "==", true), 
            orderBy('lastModified', 'desc'), 
            ...(lastPageDoc ? [startAfter(lastPageDoc)] : []), 
            limit(PAGE_LIMIT)
        );

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING PHOTOS BY SPORTS MATCH...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // -- Get ALL images from each post

        // Collect all image from posts
        let posts_With_All_Imgs = [];

        if(postList?.length > 0) {
            // Function to get post images
            async function getPostImgs(postId) {
                const docRef = doc(db, 'posts', postId)
                const colRef = collection(docRef, "img_gallery")
                
                try {
                    const galleryData = await getDocs(colRef);
                    const galleryList = galleryData.docs.map((doc) => ({...doc.data(), id: doc.id}));
                    return galleryList;
                } catch (err) {
                    console.log('ERROR:', err);
                    return [];
                }
            }

            // Use for...of to properly await async operations
            for (const post_doc of postList) {
                const postImgs = await getPostImgs(post_doc._id);

                for (const img_obj of postImgs) {
                    const imgInfo = {
                        ...post_doc,
                        img_path: img_obj.img_path,
                        img_name: img_obj.img_name,
                        width: img_obj.img_width,
                        height: img_obj.img_height
                    };
                
                    posts_With_All_Imgs.push(imgInfo);
                }
            }
        }

        // -- END: Get ALL images from each post

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        console.log('DONE GETTING PHOTOS BY SPORTS MATCH');

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: posts_With_All_Imgs
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: posts_With_All_Imgs
            });
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// filter the posts by category
export const getPostsByCategory = ({ category_obj, group_id, lastPageDoc, filter_tags }) => async dispatch => {
    dispatch(setPostsLoading());
    console.log('GETTING POSTS BY CATEGORY');

    const PAGE_LIMIT = 10;

    try {
        if(!category_obj) throw new Error("No category object provided"); 

        console.log('QUERYING POSTS BY CATEGORY');

        const category_uid = category_obj._id;
        let category_search_tags = category_obj?.search_tags?.map(tag => tag.toLowerCase()) || [];
        let category_filter_tags = filter_tags?.map(tag => replaceHyphenWithSpace(tag)) || [];

        // Create a query to retrieve posts 
        let q = query(postsCollectionRef, 
            where("search_tags", "array-contains-any", [category_uid, ...category_search_tags]), 
            ...(group_id ? [where("group._id", "==", group_id)] : [where("group", "==", null)]),
            where("post_commented_on", "==", null), 
            // add more where("field" == tag)'s for each tag in filter_tags (if it's not null)
            // caution: each unique tag must have its own index ('loooking for' & 'for sale' require two seperate indexes)
            ...(category_filter_tags?.length > 0 ? category_filter_tags.map(tag => where(`filter_tags.${tag}`, "==", true)) : []),
            orderBy('lastModified', 'desc'), 
            ...(lastPageDoc ? [startAfter(lastPageDoc)] : []), 
            limit(PAGE_LIMIT)
        );

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING CATEGORY POSTS...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // Recursively fetch comments of comments
        const fetchCommentsOfComments = async (comments) => {
            for (let i = 0; i < comments.length; i++) {
            const comment = comments[i];
            
            // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
            const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'asc'));
            
            // Execute the query and retrieve the query snapshot
            const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
            
            // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
            const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
            // Append the comments of comments to the current comment
            comment.commentsOfComments = commentsOfComments;
            
            // Recursively fetch comments of comments for the current comment
            await fetchCommentsOfComments(commentsOfComments);
            }
        };
        
        // Fetch comments of comments for the initial set of comments
        await fetchCommentsOfComments(postList);

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        console.log('DONE GETTING CATEGORY POSTS...');

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: postList
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: postList
            });
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// filter the posts with images attached
export const getCategoryPhotos = ({ category_obj, group_id, lastPageDoc }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());
    console.log('GETTING PHOTOS BY CATEGORY');

    const PAGE_LIMIT = 10;
    
    try {
        console.log('QUERYING PHOTOS BY CATEGORY');

        const category_uid = category_obj._id;
        let category_search_tags = category_obj?.search_tags || [];

        // Create a query to retrieve posts 
        let q = query(postsCollectionRef, 
            where("search_tags", "array-contains-any", [category_uid, ...category_search_tags]), 
            ...(group_id ? [where("group._id", "==", group_id)] : [where("group", "==", null)]),
            where("hasPhoto", "==", true), 
            orderBy('lastModified', 'desc'), 
            ...(lastPageDoc ? [startAfter(lastPageDoc)] : []),  
            limit(PAGE_LIMIT)
        );

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING PHOTOS BY CATEGORY...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // -- Get ALL images from each post

        // Collect all image from posts
        let posts_With_All_Imgs = [];

        if(postList?.length > 0) {
            // Function to get post images
            async function getPostImgs(postId) {
                const docRef = doc(db, 'posts', postId)
                const colRef = collection(docRef, "img_gallery")
                
                try {
                    const galleryData = await getDocs(colRef);
                    const galleryList = galleryData.docs.map((doc) => ({...doc.data(), id: doc.id}));
                    return galleryList;
                } catch (err) {
                    console.log('ERROR:', err);
                    return [];
                }
            }

            // Use for...of to properly await async operations
            for (const post_doc of postList) {
                const postImgs = await getPostImgs(post_doc._id);

                for (const img_obj of postImgs) {
                    const imgInfo = {
                        ...post_doc,
                        img_path: img_obj.img_path,
                        img_name: img_obj.img_name,
                        width: img_obj.img_width,
                        height: img_obj.img_height
                    };
                
                    posts_With_All_Imgs.push(imgInfo);
                }
            }
        }

        // -- END: Get ALL images from each post

        let lastDocument = postList[postList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        console.log('DONE GETTING PHOTOS BY CATEGORY');

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(postList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: posts_With_All_Imgs
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: posts_With_All_Imgs
            });
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with null as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
}

// Get posts user liked
export const getLikedPosts = ({ user_id, lastPageDoc, website }) => async dispatch => {

    if(!lastPageDoc) dispatch(setPostsLoading());
    
    console.log('GETTING LIKED POSTS');
    
    const PAGE_LIMIT = 10;

    try {
        console.log('QUERYING  POSTS');

        let q;

        if(website?._id) {
            if(lastPageDoc) {
                // Create a query to retrieve posts where the like_id_list contains the provided user_id, starting at the last visible document and fetch the next 3 posts.
                q = query(postsCollectionRef, where("group._id", "==", website._id), where("like_id_list", "array-contains", user_id), orderBy('lastModified', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
            } else {
                // Create a query to retrieve posts where the like_id_list contains the provided user_id
                q = query(postsCollectionRef, where("group._id", "==", website._id), where("like_id_list", "array-contains", user_id), orderBy('lastModified', 'desc'), limit(PAGE_LIMIT));
            }
        } else {
            if(lastPageDoc) {
                // Create a query to retrieve posts where the like_id_list contains the provided user_id, starting at the last visible document and fetch the next 3 posts.
                q = query(postsCollectionRef, where("like_id_list", "array-contains", user_id), orderBy('lastModified', 'desc'), startAfter(lastPageDoc), limit(PAGE_LIMIT));
            } else {
                // Create a query to retrieve posts where the like_id_list contains the provided user_id
                q = query(postsCollectionRef, where("like_id_list", "array-contains", user_id), orderBy('lastModified', 'desc'), limit(PAGE_LIMIT));
            }
        }

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('UPDATING LIKED POSTS...');
        const tempPostList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        let lastDocument = tempPostList[tempPostList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified post document in the "posts" collection 
            const docRef = doc(postsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch({
                type: SET_LAST_PAGE_DOC,
                payload: postDoc
            });

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action of type SET_POSTS or SET_LAST_POST with the posts as the payload
        if(tempPostList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_POSTS,
                payload: tempPostList
            });
        } else {
            dispatch({
                type: SET_POSTS,
                payload: tempPostList
            });
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type SET_POSTS with an empty array as the payload in case of an error
        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
};

// Fill the posts array with everything in the given array
export const setPosts = arrayOfPosts => dispatch => {

    dispatch({
        type: GET_POSTS,
        payload: arrayOfPosts
    });
};

// Fill the posts array with everything in the given array + all images from each post
export const setPostsWithImgs = arrayOfPosts => async dispatch => {
    try {
        // Collect all image from posts
        let posts_With_All_Imgs = [];

        if(arrayOfPosts?.length > 0) {
            // Function to get post images
            async function getPostImgs(postId) {
                const docRef = doc(db, 'posts', postId)
                const colRef = collection(docRef, "img_gallery")
                
                try {
                    const galleryData = await getDocs(colRef);
                    const galleryList = galleryData.docs.map((doc) => ({...doc.data(), id: doc.id}));
                    return galleryList;
                } catch (err) {
                    console.log('ERROR:', err);
                    return [];
                }
            }

            // Use for...of to properly await async operations
            for (const post_doc of arrayOfPosts) {
                const postImgs = await getPostImgs(post_doc._id);

                for (const img_obj of postImgs) {
                    const imgInfo = {
                        ...post_doc,
                        img_path: img_obj.img_path,
                        width: img_obj.img_width,
                        height: img_obj.img_height
                    };
                
                    posts_With_All_Imgs.push(imgInfo);
                }
            }
        }

        // -- END: Get ALL images from each post

        dispatch({
            type: GET_POSTS,
            payload: posts_With_All_Imgs
        });
    } catch (error) {
        console.log('ERROR!!!')
        console.log(error)

        dispatch({
            type: GET_POSTS,
            payload: []
        })
    }
};

// Add new posts to the post state inifinite scroll array
export const setSearchPosts = arrayOfPosts => dispatch => {

    dispatch({
        type: SET_POSTS,
        payload: arrayOfPosts
    });
};

// Add new posts to the post state inifinite scroll array + all images from each post
export const setSearchPosts_WithImgs = arrayOfPosts => async dispatch => {
    try {
        // Collect all image from posts
        let posts_With_All_Imgs = [];

        if(arrayOfPosts?.length > 0) {
            // Function to get post images
            async function getPostImgs(postId) {
                const docRef = doc(db, 'posts', postId)
                const colRef = collection(docRef, "img_gallery")
                
                try {
                    const galleryData = await getDocs(colRef);
                    const galleryList = galleryData.docs.map((doc) => ({...doc.data(), id: doc.id}));
                    return galleryList;
                } catch (err) {
                    console.log('ERROR:', err);
                    return [];
                }
            }

            // Use for...of to properly await async operations
            for (const post_doc of arrayOfPosts) {
                const postImgs = await getPostImgs(post_doc._id);

                for (const img_obj of postImgs) {
                    const imgInfo = {
                        ...post_doc,
                        img_path: img_obj.img_path,
                        width: img_obj.img_width,
                        height: img_obj.img_height
                    };
                
                    posts_With_All_Imgs.push(imgInfo);
                }
            }
        }

        // -- END: Get ALL images from each post

        dispatch({
            type: SET_POSTS,
            payload: posts_With_All_Imgs
        });
    } catch (error) {
        console.log('ERROR!!!')
        console.log(error)

        dispatch({
            type: SET_POSTS,
            payload: []
        })
    }
};

// Add Post
export const addPost = ({
    formData, 
    imgData, 
    imgDimensions, 
    postData,
    groupData,
    sports_match,
    goBackTo,
    website
}) => async dispatch => {
    
    try {

        if(imgData?.length > 0) {
            dispatch({
                type: POST_UPLOADING,
                payload: true
            });
        }

        // Create Post

        // Extract the necessary data from the formData object
        const {
            text,
            username,
            user
        } = formData;

        let category = null;
        let avatar = null;

        let parent_comment = null;
        let search_tags = [];
        

        // Check if the category and avatar fields exist in the formData object
        // If they exist, assign their values to the respective variables
        if(formData.category) {
            category = formData.category;
        }
        if(formData.avatar) {
            avatar = formData.avatar;
        }
        if(postData) {
            parent_comment = postData._id;
        }

        const sports_match_uid = sports_match?._id;
        if(sports_match_uid) {
            search_tags = [sports_match_uid];
            console.log('ADDING SPORTS MATCH UID TO POST', sports_match_uid)
        }

        const newPost = {
            campus_id: groupData?._id || null,
            type: "post",
            text,
            category,
            username,
            user,
            group: groupData || null,
            group_is_private: PRIVATE_TYPES.includes(groupData?.privacy) || false,
            avatar,
            post_commented_on: parent_comment,
            img_count: imgData.length,
            hasPhoto: imgData?.length > 0,
            likes: [],
            comments: [],
            date: Date.now(),
            createdAt: serverTimestamp(),
            lastModified: serverTimestamp(),
            analytics: {
                views: 0,
                accounts_reached: 0,
                direct_messages: 0,
                copied_link: 0,
                external_link_clicks: 0,
                profile_visits: 0
            },
            search_tags,
            image_analysis_completed: false,
            text_analysis_completed: false,
            buyOrSell_analysis_completed: false
        };

        // Create a new document in the "posts" collection with the post data
        const result = await addDoc(postsCollectionRef, newPost);

        console.log('POST SENT');

        // Mixpanel event tracking for post submission
        if (process.env.NODE_ENV === 'production' && user) {
            mixpanel.track("Submit Post", {
                "First Name": `${user.first_name}`,
                "Last Name": `${user.last_name}`,
                "# of Imgs": `${imgData.length}`,
                "Chosen Category": `${category}`
            });
        }

        // 1. Add Images to post
        // 2. (if comment) add the new comment to state for display w/o reloading page
        // 3. (if comment) Update the lastModified date for all the parent post documents
        // 4. (if comment) Create Notification
        // 5. (if comment) Send Email about comment

        // Determine window size breakpoints
        const isMobile = window.innerWidth <= 769;

        // --- Add Images to post ---


                // Get the document reference for the post
                const docRef = doc(db, 'posts', result.id)

                // Get the collection reference for the image gallery subcollection
                const colRef = collection(docRef, "img_gallery")

                let imgUpload_counter = 0;
                
                // Iterate over the imgData array and upload each image to the storage
                imgData.map(async (img) => {
                    
                    // Create a storage reference for the image
                    const storageRef = ref(storage, `images/posts/${result.id}/${img.name}`);

                    // Upload the image file to the storage
                    const res = await uploadBytesResumable(storageRef, img);

                    console.log('Uploaded a blob or file!');

                    // Get the download URL of the uploaded image
                    const imgPath = await getDownloadURL(storageRef);

                    // Retrieve the existing image gallery data
                    const galleryData = await getDocs(colRef);

                    let orderNum = 1;
                    
                    // If existing gallery data has documents increment to orderNum to the sum + 1
                    if(galleryData.docs && galleryData.docs.length > 0) {
                        orderNum = galleryData.docs.length + 1
                    }

                    // Find the dimensions information of the current image
                    const imgInfo = imgDimensions.find(dimensionObj => dimensionObj.fileName === img.name);

                    console.log('IMG INFO - DIMENSIONS');
                    console.log(imgInfo);

                    let newImg = {}; 

                    if(imgInfo) {

                        // Create a new image object with dimensions information
                        newImg = {
                            img_path: imgPath,
                            img_name: img.name,
                            img_order: orderNum,
                            img_width: imgInfo.width,
                            img_height: imgInfo.height
                        };
                    } else {

                        // Create a new image object without dimensions information
                        newImg = {
                            img_path: imgPath,
                            img_name: img.name,
                            img_order: orderNum,
                            img_width: 0,
                            img_height: 0
                        };
                    }

                    // Add the new image to the "img_gallery" subcollection
                    const gal = await addDoc(colRef, newImg);

                    if(imgUpload_counter + 1 === imgData.length) {
                        dispatch({
                            type: POST_UPLOADING,
                            payload: false
                        });
                        
                        if(isMobile) {
                            if(postData) {
                                localStorage.setItem("trigger_alert", "comment_success");

                                // Set a timeout to give enough time for the post to be added
                                setTimeout(() => {
                    
                                    // Display an alert message to notify the user that the post was sent
                                    // dispatch(setAlert('Posted! Your post was sent.', 'okay'));
                                    window.location.href = `/post/${result.id}`;
                                }, 1000 );
                            } else {
                                // Display an alert message to notify the user that the post was sent
                                localStorage.setItem("trigger_alert", "post_success");

                                // Set a timeout to give enough time for the post to be added
                                setTimeout(() => {

                                    if(goBackTo === "group" && groupData?._id) {
                                        window.location.href = `/groups/${groupData?._id}?show=posts`;
                                    } else {
                                        window.location.href = "/home";
                                    }
                                }, 1000 );
                            }
                        } else {
                            // Display an alert message to notify the user that the post was sent
                            dispatch(setAlert('Posted! Your post was sent.', 'okay'));
                        }

                    } else {
                        imgUpload_counter = imgUpload_counter + 1
                    }
                    
                    // await updateDoc(docRef, {
                    //     img_gallery: tempArray
                    // });
                });


            // await addImagesToPost(imgData);

        // --- END ADD IMGS ---

        if(postData) { // If post is a Comment

            // --- Add the new comment to state for display w/o reloading page

                // Fetch the added comment document
                const commentDoc = await getDoc(result);

                // Create a full comment object by merging the comment data with the added _id property
                const fullComment = {
                    ...commentDoc.data(),
                    _id: commentDoc.id
                }
                
                // Dispatch the full comment to the store using the SET_COMMENTS action type
                dispatch({
                    type: SET_COMMENTS,
                    payload: [fullComment]
                });

                dispatch({
                    type: UPDATE_LAST_POST_ADDED,
                    payload: result.id
                });

                // Display a success message to the user
                if(!isMobile){
                    dispatch(setAlert('Your reply was sent', 'okay'));
                }

            // --- END add the new comment to state for display w/o reloading page

            // --- Send Email ----

                if(!(postData.user._id === formData.user._id)) {

                    console.log('SENDING EMAIL FOR COMMENT')

                    let unRawState;
                    let unRawDescription;

                    if(formData.text !== null) {
                        
                        // Convert stringified DraftJS JSON to a raw JS object
                        const rawBlocksData = JSON.parse(formData.text);

                        // Extract just the array of text blocks
                        if (rawBlocksData && Array.isArray(rawBlocksData.blocks)) {
                            unRawState = EditorState.createWithContent(
                                convertFromRaw(rawBlocksData)
                            );

                            unRawDescription = draftToHtml(convertToRaw(unRawState.getCurrentContent()));
                        } else {
                            unRawDescription = formData.text;
                        }
                    }

                    if(postData.post_commented_on) {
                        dispatch(sendEmail({
                            formData: {                       // formData
                                type: 'comment reply',
                                to_userId: postData.user._id,
                                from_user: {
                                    first_name: formData.user.first_name,
                                    last_name: formData.user.last_name,
                                    username: formData.user.username,
                                    avatar: formData.user.img
                                },
                                postId: postData._id,
                                message: removeHtmlTags(unRawDescription)
                            },
                            website
                        }));

                        const notifyParentPosts = async (postCommentedOn) => {
                            let post = postCommentedOn;
                        
                            while (post.post_commented_on !== null) {
                            const parentPostRef = doc(db, 'posts', post.post_commented_on);
                        
                            console.log('GOT PARENT POST REFERENCE');
                        
                            // Fetch the parent post to continue the loop
                            const parentPostSnapshot = await getDoc(parentPostRef);

                            if(parentPostSnapshot.data().post_commented_on) {
                                dispatch(sendEmail({
                                    formData: {                       // formData
                                        type: 'comment interaction',
                                        to_userId: postData.user._id,
                                        from_user: {
                                            first_name: formData.user.first_name,
                                            last_name: formData.user.last_name,
                                            username: formData.user.username,
                                            avatar: formData.user.img
                                        },
                                        postId: postData._id,
                                        message: removeHtmlTags(unRawDescription)
                                    },
                                    website
                                }));
                            } else {
                                dispatch(sendEmail({
                                    formData: {                       // formData
                                        type: 'post interaction',
                                        to_userId: postData.user._id,
                                        from_user: {
                                            first_name: formData.user.first_name,
                                            last_name: formData.user.last_name,
                                            username: formData.user.username,
                                            avatar: formData.user.img
                                        },
                                        postId: postData._id,
                                        message: removeHtmlTags(unRawDescription)
                                    },
                                    website
                                }));
                            }

                            post = parentPostSnapshot.data();
                            }
                        };

                        notifyParentPosts(postData)
                    } else {
                        dispatch(sendEmail({
                            formData: {                       // formData
                                type: 'comment',
                                to_userId: postData.user._id,
                                from_user: {
                                    first_name: formData.user.first_name,
                                    last_name: formData.user.last_name,
                                    username: formData.user.username,
                                    avatar: formData.user.img
                                },
                                postId: postData._id,
                                message: removeHtmlTags(unRawDescription)
                            },
                            website
                        }));
                    }
                    
                    console.log('SENT EMAIL ACTION')
                }

            // --- END Send Email ---

            // Redirect to Post page --
            // if no images (becuase we must wait for images to finish adding)
            if(isMobile && !(imgData?.length > 0)) {
                localStorage.setItem("trigger_alert", "comment_success");
                window.location.href = `/post/${postData._id}`;
            }

            // Redirect the user to the post page
            // if(history) {
            //     window.location.href = `/post/${postData._id}`;
            //     // history.push(`/post/${postId}`);
            // }
        } else {

            dispatch({
                type: UPDATE_LAST_POST_ADDED,
                payload: result.id
            });

            dispatch({
                type: ADD_POST,
                payload: {
                    _id: result.id,
                    ...newPost
                }
            });

            // if no images (becuase we must wait for images to finish adding)
            if(isMobile && !(imgData?.length > 0)) {

                // Display an alert message to notify the user that the post was sent
                localStorage.setItem("trigger_alert", "post_success");

                // Redirect to previous page
                if(goBackTo === "group" && groupData?._id) {
                    window.location.href = `/groups/${groupData?._id}?show=posts`;
                } if(goBackTo === "sport" && sports_match?._id) {
                    window.location.href = `/vs/${sports_match?._id}`;
                } else {
                    window.location.href = "/home";
                }
            }

            if(!isMobile && !(imgData?.length > 0)){
                // Display an alert message to notify the user that the post was sent
                dispatch(setAlert('Posted! Your post was sent.', 'okay'));
            }
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err);
    //   dispatch({
    //     type: POST_ERROR,
    //     payload: { msg: err.response.statusText, status: err.response.status }
    //   });
    }
};

// Add Post
export const addReview = ({
    formData, 
    imgData, 
    imgDimensions, 
    groupData,
    toUser
}) => async dispatch => {

    if(!toUser) {
        throw new Error("No To User Data provided");
    }

    if(!formData.user) {
        throw new Error("No User Data provided");
    }

    const toUser_Doc = {
        _id: toUser?._id,
        first_name: toUser?.first_name,
        last_name: toUser?.last_name,
        img: toUser?.img,
        username: toUser?.username
    };

    if( toUser_Doc._id === formData?.user?._id) {
        throw new Error("Can't review your own profile");
    }

    try {

        if(imgData?.length > 0) {
            dispatch({
                type: POST_UPLOADING,
                payload: true
            });
        }

        // Create Review

        // Extract the necessary data from the formData object
        const {
            text,
            username,
            user
        } = formData;

        let avatar = null;
        
        if(formData.avatar) {
            avatar = formData.avatar;
        }

        const newReview = {
            campus_id: groupData?._id || null,
            type: "user",
            text,
            username,
            user,
            to_user: toUser_Doc,
            group: groupData || null,
            group_is_private: PRIVATE_TYPES.includes(groupData?.privacy) || false,
            avatar,
            post_commented_on: null,
            img_count: imgData.length,
            hasPhoto: imgData?.length > 0,
            likes: [],
            date: Date.now(),
            createdAt: serverTimestamp(),
            lastModified: serverTimestamp(),
        };

        // Create a new document in the "reviews" collection with the data
        const result = await addDoc(reviewsCollectionRef, newReview);

        console.log('REVIEW SENT');

        // Mixpanel event tracking for post submission
        if (process.env.NODE_ENV === 'production' && user) {
            mixpanel.track("Submit Review", {
                "First Name": `${user.first_name}`,
                "Last Name": `${user.last_name}`,
                "# of Imgs": `${imgData.length}`,
                "Type":  "user",
                "To ID": `${toUser_Doc._id}`
            });
        }

        // 1. Add Images to post
        // 2. (if comment) add the new comment to state for display w/o reloading page
        // 3. (if comment) Update the lastModified date for all the parent post documents
        // 4. (if comment) Create Notification
        // 5. (if comment) Send Email about comment

        // Determine window size breakpoints
        const isMobile = window.innerWidth <= 769;

        // --- Add Images to post ---

        // Get the document reference for the post
        const docRef = doc(db, 'reviews', result.id)

        // Get the collection reference for the image gallery subcollection
        const colRef = collection(docRef, "img_gallery")

        let imgUpload_counter = 0;
        
        // Iterate over the imgData array and upload each image to the storage
        imgData.map(async (img) => {
            
            // Create a storage reference for the image
            const storageRef = ref(storage, `images/reviews/${result.id}/${img.name}`);

            // Upload the image file to the storage
            const res = await uploadBytesResumable(storageRef, img);

            console.log('Uploaded a blob or file!');

            // Get the download URL of the uploaded image
            const imgPath = await getDownloadURL(storageRef);

            // Retrieve the existing image gallery data
            const galleryData = await getDocs(colRef);

            let orderNum = 1;
            
            // If existing gallery data has documents increment to orderNum to the sum + 1
            if(galleryData.docs && galleryData.docs.length > 0) {
                orderNum = galleryData.docs.length + 1
            }

            // Find the dimensions information of the current image
            const imgInfo = imgDimensions.find(dimensionObj => dimensionObj.fileName === img.name);

            let newImg = {}; 

            if(imgInfo) {

                // Create a new image object with dimensions information
                newImg = {
                    img_path: imgPath,
                    img_name: img.name,
                    img_order: orderNum,
                    img_width: imgInfo.width,
                    img_height: imgInfo.height
                };
            } else {

                // Create a new image object without dimensions information
                newImg = {
                    img_path: imgPath,
                    img_name: img.name,
                    img_order: orderNum,
                    img_width: 0,
                    img_height: 0
                };
            }

            // Add the new image to the "img_gallery" subcollection
            const gal = await addDoc(colRef, newImg);

            if(imgUpload_counter + 1 === imgData.length) {
                dispatch({
                    type: POST_UPLOADING,
                    payload: false
                });
                
                if(isMobile) {
                    // Display an alert message to notify the user that the post was sent
                    localStorage.setItem("trigger_alert", "post_success");

                    // Set a timeout to give enough time for the post to be added
                    setTimeout(() => {

                        if(toUser_Doc._id) {
                            window.location.href = `/user/${toUser_Doc._id}?show=reviews`;
                        } else {
                            window.location.href = "/home";
                        }
                    }, 1000 );
                } else {
                    // Display an alert message to notify the user that the post was sent
                    dispatch(setAlert('Posted! Your review was sent.', 'okay'));
                }

            } else {
                imgUpload_counter = imgUpload_counter + 1
            }
            
            // await updateDoc(docRef, {
            //     img_gallery: tempArray
            // });
        });


        // await addImagesToPost(imgData);

        // --- END ADD IMGS ---

        // --- Create Notification ---- >

        if(!(toUser_Doc._id === user._id)) {

            const payload = {
                type: 'review',
                reviewId: result.id,
                message: text,
                toId: toUser_Doc._id,
                from_username: username,
                avatar: avatar, // from user
                date: Date.now()
            }

            // Trigger cloud function to create notification
            createNotification_InCloud(payload)
                .then(() => console.log("Notification created successfully!"))
                .catch((err) => console.log("Notification failed to create"));
        }

    // --- END Create Notification ---- >

        dispatch({
            type: UPDATE_LAST_POST_ADDED,
            payload: result.id
        });

        dispatch({
            type: ADD_POST,
            payload: {
                _id: result.id,
                ...newReview
            }
        });

        // if no images (becuase we must wait for images to finish adding)
        if(isMobile && !(imgData?.length > 0)) {

            // Display an alert message to notify the user that the post was sent
            localStorage.setItem("trigger_alert", "post_success");

            // Redirect to previous page
            if(toUser_Doc._id) {
                window.location.href = `/user/${toUser_Doc._id}?show=reviews`;
            } else {
                window.location.href = "/home";
            }
        }

        if(!isMobile && !(imgData?.length > 0)){
            // Display an alert message to notify the user that the review was sent
            dispatch(setAlert('Posted! Your review was sent.', 'okay'));
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err);
    //   dispatch({
    //     type: POST_ERROR,
    //     payload: { msg: err.response.statusText, status: err.response.status }
    //   });
    }
};

// Add Comment to a Review
export const addReviewComment = ({
    formData, 
    imgData, 
    imgDimensions, 
    postData,
    groupData
}) => async dispatch => {
    
    if(!postData) {
        throw new Error("No Review Data provided");
    }

    try {

        if(imgData?.length > 0) {
            dispatch({
                type: POST_UPLOADING,
                payload: true
            });
        }

        // Create Post

        // Extract the necessary data from the formData object
        const {
            text,
            username,
            user
        } = formData;

        let avatar = null;

        let parent_comment = null;
        
        if(formData.avatar) {
            avatar = formData.avatar;
        }
        if(postData) {
            parent_comment = postData._id;
        }

        const newPost = {
            campus_id: groupData?._id || null,
            type: "comment",
            text,
            username,
            user,
            to_user: null,
            group: groupData || null,
            group_is_private: PRIVATE_TYPES.includes(groupData?.privacy) || false,
            avatar,
            post_commented_on: parent_comment,
            img_count: imgData.length,
            hasPhoto: imgData?.length > 0,
            likes: [],
            date: Date.now(),
            createdAt: serverTimestamp(),
            lastModified: serverTimestamp(),
        };

        // Create a new document
        const result = await addDoc(reviewsCollectionRef, newPost);

        console.log('COMMENT SENT');

        // Mixpanel event tracking for post submission
        if (process.env.NODE_ENV === 'production' && user) {
            mixpanel.track("Reply to Review", {
                "First Name": `${user.first_name}`,
                "Last Name": `${user.last_name}`,
                "# of Imgs": `${imgData.length}`,
                "Review ID": `${parent_comment}`
            });
        }

        // 1. Add Images to post
        // 2. add the new comment to state for display w/o reloading page

        // Determine window size breakpoints
        const isMobile = window.innerWidth <= 769;

        // --- Add Images to post ---


        // Get the document reference for the post
        const docRef = doc(reviewsCollectionRef, result.id)

        // Get the collection reference for the image gallery subcollection
        const colRef = collection(docRef, "img_gallery")

        let imgUpload_counter = 0;
        
        // Iterate over the imgData array and upload each image to the storage
        imgData.map(async (img) => {
            
            // Create a storage reference for the image
            const storageRef = ref(storage, `images/reviews/${result.id}/${img.name}`);

            // Upload the image file to the storage
            const res = await uploadBytesResumable(storageRef, img);

            console.log('Uploaded a blob or file!');

            // Get the download URL of the uploaded image
            const imgPath = await getDownloadURL(storageRef);

            // Retrieve the existing image gallery data
            const galleryData = await getDocs(colRef);

            let orderNum = 1;
            
            // If existing gallery data has documents increment to orderNum to the sum + 1
            if(galleryData.docs && galleryData.docs.length > 0) {
                orderNum = galleryData.docs.length + 1
            }

            // Find the dimensions information of the current image
            const imgInfo = imgDimensions.find(dimensionObj => dimensionObj.fileName === img.name);

            console.log('IMG INFO - DIMENSIONS');
            console.log(imgInfo);

            let newImg = {}; 

            if(imgInfo) {

                // Create a new image object with dimensions information
                newImg = {
                    img_path: imgPath,
                    img_name: img.name,
                    img_order: orderNum,
                    img_width: imgInfo.width,
                    img_height: imgInfo.height
                };
            } else {

                // Create a new image object without dimensions information
                newImg = {
                    img_path: imgPath,
                    img_name: img.name,
                    img_order: orderNum,
                    img_width: 0,
                    img_height: 0
                };
            }

            // Add the new image to the "img_gallery" subcollection
            const gal = await addDoc(colRef, newImg);

            if(imgUpload_counter + 1 === imgData.length) {
                dispatch({
                    type: POST_UPLOADING,
                    payload: false
                });
                
                if(isMobile) {
                    localStorage.setItem("trigger_alert", "comment_success");

                    // Set a timeout to give enough time for the post to be added
                    setTimeout(() => {
        
                        // Display an alert message to notify the user that the post was sent
                        // dispatch(setAlert('Posted! Your post was sent.', 'okay'));
                        window.location.href = `/review/${parent_comment}`;
                    }, 1000 );
                } else {
                    // Display an alert message to notify the user that the comment was sent
                    dispatch(setAlert('Posted! Your comment was sent.', 'okay'));
                }

            } else {
                imgUpload_counter = imgUpload_counter + 1
            }
            
            // await updateDoc(docRef, {
            //     img_gallery: tempArray
            // });
        });

        // --- END ADD IMGS ---

        // --- Create Notification ---- >

        if(!(postData.user._id === user._id)) {

            const payload = {
                type: 'review comment',
                reviewId: parent_comment,
                message: text,
                toId: postData.user._id,
                from_username: username,
                avatar: avatar, // from user
                date: Date.now()
            }

            // Trigger cloud function to create notification
            createNotification_InCloud(payload)
                .then(() => console.log("Notification created successfully!"))
                .catch((err) => console.log("Notification failed to create"));
        }

    // --- END Create Notification ---- >

        // --- Add the new comment to state for display w/o reloading page

        // Fetch the added comment document
        const commentDoc = await getDoc(result);

        // Create a full comment object by merging the comment data with the added _id property
        const fullComment = {
            ...commentDoc.data(),
            _id: commentDoc.id
        }
        
        // Dispatch the full comment to the store using the SET_COMMENTS action type
        dispatch({
            type: SET_COMMENTS,
            payload: [fullComment]
        });

        dispatch({
            type: UPDATE_LAST_POST_ADDED,
            payload: result.id
        });

        // Display a success message to the user
        if(!isMobile){
            dispatch(setAlert('Your reply was sent', 'okay'));
        }

        // --- END add the new comment to state for display w/o reloading page

        // Redirect to Post page --
        // if no images (becuase we must wait for images to finish adding)
        if(isMobile && !(imgData?.length > 0)) {
            localStorage.setItem("trigger_alert", "comment_success");
            window.location.href = `/review/${parent_comment}`;
        }
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err);
    //   dispatch({
    //     type: POST_ERROR,
    //     payload: { msg: err.response.statusText, status: err.response.status }
    //   });
    }
};

// Delete Post
export const deletePost = (postId) => async dispatch => {
    console.log('DELETING POST!!!!!')

    // Get reference to the post document
    const postRef = doc(db, 'posts', postId)

    try {

        // --- DELETE POST ---

        // Fetch the post document
        const postDoc = await getDoc(postRef);
        
        // Delete the post document
        await deleteDoc(postRef);

        // --- END DELETE POST ---
        
        if(!postDoc.data().post_commented_on) {
            // Dispatch the DELETE_POST action with the postId
            dispatch({
                type: DELETE_POST,
                payload: postId
            });

            // Clear the currently displayed post
            dispatch(clearPost());

            // Set an alert to inform the user that the post was deleted
            dispatch(setAlert('Your post was deleted', 'okay'));
        } else {

            // Dispatch the REMOVE_COMMENT action with the commentId payload to remove the comment from the state
            dispatch({
                type: REMOVE_COMMENT,
                payload: postDoc.id
            });

            // Display a success alert
            dispatch(setAlert('Comment Removed', 'success'));
        }

    } catch (err) {
        console.log('ERROR');
        console.log(err);

        dispatch(setAlert('Something went wrong', 'danger'));
    //     dispatch({
    //         type: POST_ERROR,
    //         payload: { msg: err.response.statusText, status: err.response.status }
    //     });
    }
}

export const setPostUploadingImgs = (value) => dispatch => {
    dispatch({
        type: POST_UPLOADING_IMGS,
        payload: value
    });
}

// Add like
export const addLike = ({ postId, fromUserData, postData, website }) => async dispatch => {
    
    // Get the current list of likes from the post data
    const likeList = postData.likes;
    
    try {
        console.log('ADDING LIKE!!!!!')

        // Get Firebase Post & Likes of post collection ref
        const postRef = doc(db, 'posts', postId)
        const colRef = collection(postRef, "likes")
        
        // Create the new like object
        const newLike = {
            user: {
                _id: fromUserData._id,
                username: fromUserData.username,
                first_name: fromUserData.first_name,
                last_name: fromUserData.last_name,
                img: fromUserData.img
            }
        };

        // Check if post already liked by same user
        if(likeList.filter(like => like.user._id.toString() === fromUserData._id).length > 0) {
            // Get the index of the like to remove
            const removeIndex = likeList.map(like => like.user._id.toString()).indexOf(fromUserData._id);

            const likeID = likeList[removeIndex]._id;

            // Remove the like from the post
            likeList.splice(removeIndex, 1);

            // Create array for the list of like ID's
            const id_array = [];

            likeList.map((like) => {
                id_array.push(like.user._id);
            })

            // Update the post document with the updated likes and like_id_list
            await updateDoc(postRef, {
                likes: likeList,
                like_id_list: id_array
            })
        } else {
            // const likeData = await addDoc(colRef, newLike);

            // Add the new like to the likeList
            likeList.push(newLike);

            // Create array for the list of like ID's
            const id_array = [];

            likeList.map((like) => {
                id_array.push(like.user._id);
            })

            // Update the post document with the updated likes and like_id_list
            await updateDoc(postRef, {
                likes: likeList,
                like_id_list: id_array
            })

            console.log('SUCCESSFULLY LIKED');
            

            // Dispatch an alert to indicate that the post was saved
            dispatch(setAlert('Post saved.', 'okay'));

            // --- Create Notification ---- >

                if(!(postData.user._id === fromUserData._id)) {

                    const payload = {
                        type: 'like',
                        postId: postId,
                        message: postData.text,
                        toId: postData.user._id,
                        from_username: `${fromUserData.first_name || ""} ${fromUserData.last_name || ""}`,
                        avatar: fromUserData.img, // from user
                        date: Date.now()
                    }

                    // Trigger cloud function to create notification
                    createNotification_InCloud(payload)
                        .then(() => console.log("Notification created successfully!"))
                        .catch((err) => console.log("Notification failed to create"));
                }

            // --- END Create Notification

            // --- Send Email ----

            if(!(postData.user._id === fromUserData._id)) {
                
                console.log('SENDING EMAIL FOR LIKE')

                let unRawState;
                let unRawDescription;

                if(postData.text !== null) {

                    // Convert stringified DraftJS JSON to a raw JS object
                    const rawBlocksData = JSON.parse(postData.text);

                    // Extract just the array of text blocks
                    if (rawBlocksData && Array.isArray(rawBlocksData.blocks)) {
                        unRawState = EditorState.createWithContent(
                            convertFromRaw(rawBlocksData)
                        );

                        unRawDescription = draftToHtml(convertToRaw(unRawState.getCurrentContent()));
                    } else {
                        unRawDescription = postData.text;
                    }
                }

                dispatch(sendEmail({
                    formData: {                       // formData
                        type: 'like',
                        to_userId: postData.user._id,   // toId
                        from_user: {
                            first_name: fromUserData.first_name,  // first_name
                            last_name: fromUserData.last_name,   // last_name
                            username: fromUserData.username,   // username
                            avatar: fromUserData.img         // avatar
                        },
                        postId: postId,
                        message: removeHtmlTags(unRawDescription)
                    },
                    website
                }));
                
                console.log('SENT EMAIL ACTION')
            }

            // --- END Send Email ---
        }
  
    //   dispatch({
    //     type: UPDATE_POST_LIKES,
    //     payload: { id, likes: res.data }
    //   });

      
    } catch (err) {
      console.log(err)
    }
};

// Get Post Comment
export const getComments = (postId) => async dispatch => {
    dispatch(setCommentsLoading());
    console.log('GETTING COMMENTS')

    try {
        // Create a query to retrieve comments where the post_commented_on field matches the provided post ID, ordered by creation date in descending order
        const commentQuery = query(postsCollectionRef, where("post_commented_on", "==", postId), orderBy('createdAt', 'asc'));
      
        // Execute the query and retrieve the query snapshot
        const querySnapshot = await getDocs(commentQuery);
      
        // Map through the document snapshots in the query snapshot and extract the data and ID for each comment
        const postComments = querySnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
      
        // Recursively fetch comments of comments
        const fetchCommentsOfComments = async (comments) => {
          for (let i = 0; i < comments.length; i++) {
            const comment = comments[i];
            
            // Create a query to retrieve comments where the post_commented_on field matches the comment ID, ordered by creation date in descending order
            const commentOfCommentQuery = query(postsCollectionRef, where("post_commented_on", "==", comment._id), orderBy('createdAt', 'desc'));
            
            // Execute the query and retrieve the query snapshot
            const commentOfCommentSnapshot = await getDocs(commentOfCommentQuery);
            
            // Map through the document snapshots in the query snapshot and extract the data and ID for each comment of comment
            const commentsOfComments = commentOfCommentSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
            // Append the comments of comments to the current comment
            comment.commentsOfComments = commentsOfComments;
            
            // Recursively fetch comments of comments for the current comment
            await fetchCommentsOfComments(commentsOfComments);
          }
        };
      
        // Fetch comments of comments for the initial set of comments
        await fetchCommentsOfComments(postComments);
      
        // Now postComments array contains all comments and comments of comments
        console.log('--- > ALL COMMENTS');

        dispatch({
            type: GET_COMMENTS,
            payload: postComments
        });
      } catch (error) {
        console.log('ERROR');
        console.log(error);
      }

    // try {
    //     console.log('GETTING COMMENTS 2')

    //     // Get the reference to the post and comments collection
    //     const postRef = doc(db, 'posts', postId);
    //     const commentsCollectionRef = collection(postRef, "comments")

    //     // Create a query to fetch the comments in descending order of createdAt
    //     const q = query(commentsCollectionRef, orderBy('createdAt', 'desc'));

    //     // Fetch the comment data
    //     const commentData = await getDocs(q);

    //     // Map the comment documents to an array of comment objects with the added _id property
    //     const commentList = commentData.docs.map((doc) => ({...doc.data(), _id: doc.id}));

    //     console.log('SHOW POST COMMENTS ListN ACTIONS');
    //     console.log(commentList)
    
    //     // Dispatch the comment list to the store
    //     dispatch({
    //         type: GET_COMMENTS,
    //         payload: commentList
    //     });

    // } catch (err) {
    //     console.log(err)

    //     // If an error occurs, dispatch an empty comment list to the store
    //     dispatch({
    //         type: SET_COMMENTS,
    //         payload: []
    //     })
    // }
}

// Delete Comment
export const deleteComment = (postId, commentId) => async dispatch => {
    console.log('DELETING COMMENT!!!!!')

    // Delete comment from post
    const docRef = doc(db, `posts/${postId}/comments`, commentId)

    try {
        console.log('IN DELETE COMMENT');

        // Delete the comment document
        await deleteDoc(docRef);

        // Dispatch the REMOVE_COMMENT action with the commentId payload to remove the comment from the state
        dispatch({
            type: REMOVE_COMMENT,
            payload: commentId
        });

        // Display a success alert
        dispatch(setAlert('Comment Removed', 'success'));

    } catch (err) {

        console.log('ERROR');
        console.log(err);

        // Display an error alert if something goes wrong during the deletion
        dispatch(setAlert('Something went wrong', 'danger'));

        // Uncomment the following code if you have specific error handling logic or dispatches for the POST_ERROR action
        // dispatch({
        //     type: POST_ERROR,
        //     payload: { msg: err.response.statusText, status: err.response.status }
        // });
    }
}   

// Set State of Text Editor
export const setEditorText = editorData => dispatch => {

    dispatch({
        type: UPDATE_EDITOR_TEXT,
        payload: editorData
    });
};

// Clear Editor Text
export const clearEditorText = () => dispatch => {
    dispatch({
        type: CLEAR_EDITOR_TEXT
    });

}

// Set State of Editor Category
export const setEditorCategory = categoryData => dispatch => {

    dispatch({
        type: UPDATE_EDITOR_CATEGORY,
        payload: categoryData
    });
};

// Clear Editor Category
export const clearEditorCategory = () => dispatch => {
    dispatch({
        type: CLEAR_EDITOR_CATEGORY
    });
}

// Set State of Editor Files
export const setEditorFiles = fileData => dispatch => {

    dispatch({
        type: UPDATE_EDITOR_FILES,
        payload: fileData
    });
};

// Clear Editor File State
export const clearEditorFiles = () => dispatch => {
    dispatch({
        type: CLEAR_EDITOR_FILES
    });

}

// Add 1 Temporary Image url to urls
export const setTemporaryUrls = urlData => dispatch => {
    // console.log('LOOK FOR URL HERE');
    // console.log(urlData);
    dispatch({
        type: UPDATE_URLS,
        payload: urlData
    });
};

// Remove 1 url from urls
export const removeTempUrl = index => dispatch => {
    console.log('LOOK FOR REMOVE INDEX HERE');
    console.log(index);
    dispatch({
        type: REMOVE_URL,
        payload: index
    });
};

// Clear temp urls
export const clearUrls = () => dispatch => {
    dispatch({
        type: CLEAR_URLS
    });

}

// Posts loading
export const setPostsLoading = () => {
    return {
        type: POSTS_LOADING
    }
}

// Comments loading
export const setCommentsLoading = () => {
    return {
        type: COMMENTS_LOADING
    }
}

// Remove all posts
export const clearPosts = () => dispatch => {

    // Dispatch an action to set loading state for posts
    dispatch(setPostsLoading());

    dispatch({
        type: CLEAR_POSTS
    });

}

// Remove all posts
export const clearPost = () => dispatch => {
    dispatch({
        type: CLEAR_POST
    });

}

// --- Infinite Scroll Functions ---

export const set_ShowBottomSpinner = (value) => dispatch => {

    dispatch({
        type: SET_SHOW_BOTTOM_SPINNER,
        payload: value
    });

}

export const set_LastPageDoc = (productDoc) => dispatch => {

    dispatch({
        type: SET_LAST_PAGE_DOC,
        payload: productDoc
    });

}

export const set_NoMorePosts = (value) => dispatch => {

    dispatch({
        type: SET_NO_MORE_POSTS,
        payload: value
    });

}

// --- END: Infinite Scroll Functions ---


// ---------------------------------------- //
// ------- Helper functions -------------
// ----------------------------------------

// Insert Ads into feed list
const insertSponsoredPosts = async ({posts, analyticsMetaData}) => {

    console.log('Start inserting ads into posts');

    let ads = [];

    try {
        const temp_ads_list = await getAdsTurnToPosts_Helper();
        ads = [...temp_ads_list];
    } catch (error) {
        console.log('Failed to get ads');
        console.log(error);
    }

    if(ads === null || ads.length <= 0) {
        return posts;
    }

    const result = [];

    const sponsoredAds = ads;

    const sponsoredIndex_Ref = analyticsMetaData.sponsoredIndex;
    let nextSponsoredIndex = sponsoredIndex_Ref ? sponsoredIndex_Ref.current : 0;; 
    
    posts.forEach((post, index) => {
        result.push(post);
        
        // Insert sponsored post after every 2 regular posts
        if ((index + 1) % 4 === 0) {
            const sponsoredContent = sponsoredAds[nextSponsoredIndex % sponsoredAds.length];
            
            // -- Analytics stuff
            safeTrackPostAnalytics({actionType: 'view', postId: sponsoredContent._id, analyticsMetaData});

            // -- END: Analytics stuff
            
            result.push(sponsoredContent);
            
            nextSponsoredIndex++;
        }
    });

    if(nextSponsoredIndex !== sponsoredIndex_Ref.current) {
        sponsoredIndex_Ref.current = nextSponsoredIndex;
    }
    
    return result;
};

// Get Posts By User Id
export const getUserTotalPosts_Helper = async ({ user_id, website }) => {

    console.log('GETTING TOTAL USER POSTS #');

    try {
        console.log('QUERYING TOTAL USER POSTS #');

        if(!user_id) {
            throw new Error("user ID is required");
        }

        // Create a query to retrieve posts where the user ID matches the provided ID, ordered by creation date in descending order
        let q;

        if(website?._id) {
            // Create a query to retrieve posts 
            q = query(postsCollectionRef, where("group._id", "==", website._id), where("user._id", "==", user_id), where("post_commented_on", "==", null), where("type", "==", "post"));
        } else {

            // Create a query to retrieve posts 
            q = query(postsCollectionRef, where("user._id", "==", user_id), where("post_commented_on", "==", null), where("type", "==", "post"));
        }

        // Fetch posts
        const snapshot = await getDocs(q);

        console.log('DONE GETTING USER TOTAL POSTS #...');
        const postList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
        
        const totalPostsCount = postList?.length || 0;

        return totalPostsCount;

    } catch (err) {
        console.log("ERROR! Failed to get user's total post count")
        console.log(err)

        return null;
    }
};

// ---------------------------------------- //
// ------- BULK DB minipulation functions -------------
// ----------------------------------------

// export const addHasPhotoFieldToPosts = () => async dispatch => {
//     const updatePostsHasPhoto = async () => {
//         console.log('UPDATING: HAS PHOTO POSTS NOW...');
//         dispatch(setAlert('UPDATING HAS PHOTO POSTS NOW...', 'okay'));

//         const postsCollectionRef = collection(db, 'posts');
//         const querySnapshot = await getDocs(postsCollectionRef);
        
//         const BATCH_SIZE = 50; // Process in smaller batches
//         let successCount = 0;
//         let errorCount = 0;
        
//         // Process documents in batches
//         for (let i = 0; i < querySnapshot.docs.length; i += BATCH_SIZE) {
//             const batch = querySnapshot.docs.slice(i, i + BATCH_SIZE);
            
//             const batchPromises = batch.map(async (documentSnapshot) => {
//                 try {
//                     const postData = documentSnapshot.data();
//                     const updateData = {};
                    
//                     // Add hasPhoto field based on img_count
//                     updateData.hasPhoto = postData?.img_count > 0;
                    
//                     const postRef = doc(db, 'posts', documentSnapshot.id);
//                     await updateDoc(postRef, updateData);
//                     successCount++;
//                 } catch (error) {
//                     console.error(`Failed to update post ${documentSnapshot.id}:`, error);
//                     errorCount++;
//                 }
//             });
            
//             await Promise.all(batchPromises);
            
//             // Log progress
//             console.log(`Progress: ${i + batch.length}/${querySnapshot.docs.length} documents processed`);
//             dispatch(setAlert(`Progress: ${successCount} updated, ${errorCount} errors`, 'okay'));
            
//             // Small delay between batches to avoid rate limits
//             if (i + BATCH_SIZE < querySnapshot.docs.length) {
//                 await new Promise(resolve => setTimeout(resolve, 100));
//             }
//         }
        
//         dispatch(setAlert(`Complete: ${successCount} updated, ${errorCount} errors`, 'okay'));
//         console.log(`Complete: ${successCount} updated successfully, ${errorCount} errors.`);
//     };
      
//     await updatePostsHasPhoto();
// }

// export const addPostCommentedOnFieldToPosts = () => async dispatch => {
//     const addPostCommentedOnField = async () => {
//         console.log('ADDING: PARENT COMMENT TO POSTS NOW...');
//         dispatch(setAlert('ADDING: PARENT COMMENT TO POSTS NOW...', 'okay'));

//         const postsCollectionRef = collection(db, 'posts');
//         const querySnapshot = await getDocs(postsCollectionRef);
        
//         const updatePromises = querySnapshot.docs.map(async (documentSnapshot) => {
//             if(!documentSnapshot.data().post_commented_on) {
        
//                 const postRef = doc(db, 'posts', documentSnapshot.id);
//                 await updateDoc(postRef, {
//                     post_commented_on: null
//                 });
//             }
//         });
        
//         await Promise.all(updatePromises);
        
//         dispatch(setAlert('All posts updated successfully', 'okay'));

//         console.log('All posts updated successfully.');
//     };
      
//     // Call the function to update all the posts
//     await addPostCommentedOnField();

// }

// export const createPostForAllNestedComments = () => async dispatch => {
//     const swapNestedCommentsToPosts = async () => {
//         console.log('SWITCHING: NESTED COMMENTS TO POSTS NOW...');
//         dispatch(setAlert('SWITCHING NESTED COMMENTS TO POSTS NOW...', 'okay'));

//         const postsCollectionRef = collection(db, 'posts');
//         const querySnapshot = await getDocs(postsCollectionRef);
        
//         const updatePromises = querySnapshot.docs.map(async (documentSnapshot) => {

//             console.log('GETTING POST COMMENTS')

//             // Get the reference to the post and comments collection
//             const postRef = doc(db, 'posts', documentSnapshot.id);
//             const commentsCollectionRef = collection(postRef, "comments")

//             // Fetch the comment data
//             const commentData = await getDocs(commentsCollectionRef);

//             if(commentData && commentData.docs?.length > 0) {
//                 // Map the comment documents to an array of comment objects with the added _id property
//                 commentData.docs.map(async (commentDoc) => {
//                     let category = null;
//                     let avatar = null;

//                     if(commentDoc.data().user.img) {
//                         avatar = commentDoc.data().user.img;
//                     }
            
//                     // Create a new document in the "posts" collection with the post data
//                     await addDoc(postsCollectionRef, {
//                         text: commentDoc.data().text,
//                         category,
//                         username: `${commentDoc.data().user.first_name}${commentDoc.data().user.last_name && ' ' + commentDoc.data().user.last_name}`,
//                         user: commentDoc.data().user,
//                         avatar,
//                         post_commented_on: documentSnapshot.id,
//                         img_count: 0,
//                         likes: [],
//                         comments: [],
//                         date: commentDoc.data().date,
//                         createdAt: commentDoc.data().createdAt,
//                         lastModified: commentDoc.data().createdAt
//                     });

//                     // Delete the comment from the post sub-collection
//                     const commentRef = doc(db, `posts/${documentSnapshot.id}/comments`, commentDoc.id)
//                     await deleteDoc(commentRef);
//                 });
            
        
//             }
//         });
        
//         await Promise.all(updatePromises);
        
//         dispatch(setAlert('All posts updated successfully', 'okay'));

//         console.log('All posts updated successfully.');
//     };
      
//     // Call the function to update all the posts
//     await swapNestedCommentsToPosts();

// }

// ADD OU campus_id to all current users
// export const add_campus_id_to_all_posts = () => async dispatch => {

//     console.log('ADDING CAMPUS ID TO POSTS...');

//     // Try block to handle the update operation
//     try {
  
//         console.log('GETTING ALL POSTS')

//         // Retrieve all documents from the 'users' collection
//         const data = await getDocs(postsCollectionRef);

//         // Create a user list by mapping each document to an object and including the document ID
//         const postList = data.docs.map((doc) => ({...doc.data(), _id: doc.id}));

//         console.log('SHOW POST LIST')
//         console.log(postList);

//         // Loop through the post list and update each document with the 'campus_id' field
//         postList.forEach(async (post) => {

//             // Reference to the post document in the Firestore database
//             const postDoc = doc(db, "posts", post._id);

//             try {
//                 console.log('ADDING FIELD')
//                 // Update the post doc by adding the campus_id field
//                 await updateDoc(postDoc, {
//                     campus_id: 'b7nqQGbbbzw08uh0MoPA',
//                 })
//             } catch (error) {
//                 console.log('ERROR UPDATING USER');
//                 console.log(error)
//             }

//         });

//         // Dispatch a success alert indicating that the profile has been updated
//         dispatch(setAlert('DONE Updating Posts!', 'success'));

//     } catch (err) {
//         console.log('ERRORS')
//         console.log(err);
        
//         // Display a generic error message if no specific error response is received
//         setAlert('Something went wrong', 'danger')
//     }
// }
  
// export const bulkUpdatePostsWithGroups = () => async dispatch => {
//     console.log('UPDATING: ADDING GROUPS TO POSTS NOW...');
//     dispatch(setAlert('UPDATING: ADDING GROUPS TO POSTS NOW...', 'okay'));

//     try {
//         const postsSnapshot = await getDocs(collection(db, 'posts'));
  
//       console.log(`Found ${postsSnapshot.size} posts`);
  
//       const BATCH_SIZE = 450;
  
//       let batch = writeBatch(db);
//       let batchCount = 0;
  
//       let updated = 0;
//       let skipped = 0;
  
//       for (const postDoc of postsSnapshot.docs) {
//         const post = postDoc.data();
  
//         const group = post.group;
//         const campusId = post.campus_id;
  
//         // Skip if there is no group
//         if (!group) {
//           skipped++;
//           continue;
//         }
  
//         // Skip if group already has an _id
//         if (group._id !== undefined && group._id !== null) {
//           skipped++;
//           continue;
//         }
  
//         // Skip if there is no campus_id to use
//         if (!campusId) {
//           skipped++;
//           continue;
//         }
  
//         // Add _id to the existing group object
//         batch.update(postDoc.ref, {
//           group: {
//             ...group,
//             _id: campusId,
//           },
//         });
  
//         updated++;
//         batchCount++;
  
//         // Commit every 450 updates
//         if (batchCount >= BATCH_SIZE) {
//           await batch.commit();
  
//           console.log(`Committed batch of ${batchCount} updates`);
  
//           batch = writeBatch(db);
//           batchCount = 0;
//         }
//       }
  
//       // Commit remaining updates
//       if (batchCount > 0) {
//         await batch.commit();
  
//         console.log(`Committed final batch of ${batchCount} updates`);
//       }

//         console.log(
//             `Done. Updated: ${updated}, skipped: ${skipped}`
//         );

//         dispatch(setAlert('DONE Updating Posts!', 'success'));
    
//         return {
//             updated,
//             skipped
//         };
//     } catch (error) {
//         console.log('Error updating posts')
//         console.log(error);

//         dispatch(setAlert('Something went wrong', 'danger'));
//     }
// }
